import { color } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import { createGlobalStyle } from "styled-components";
export const GlobalStyle = createGlobalStyle `
  :host, :root {
    background-color: ${color.background.light};
  }

  body {
    scrollbar-gutter: stable;
    //noinspection CssInvalidPropertyValue
    overflow-x: overlay;
  }

  body, html {
    min-height: calc(100dvh);
    padding: 0;
    margin: 0;
  }
`;
export default GlobalStyle;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2xvYmFsU3R5bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9CYWNrc2lkZVJlbmRlcmVyL0dsb2JhbFN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxnREFBZ0QsQ0FBQztBQUN2RSxPQUFPLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUV0RCxNQUFNLENBQUMsTUFBTSxXQUFXLEdBQUcsaUJBQWlCLENBQUE7O3dCQUVwQixLQUFLLENBQUMsVUFBVSxDQUFDLEtBQUs7Ozs7Ozs7Ozs7Ozs7O0NBYzdDLENBQUM7QUFFRixlQUFlLFdBQVcsQ0FBQyJ9